<template><!-- svgo-optimised -->
<svg class="icon icon__play" viewBox="0 0 21.33 24.89" xmlns="http://www.w3.org/2000/svg"><path d="M21.33 12.44 0 24.89V0l21.33 12.44Z"/></svg></template>